import { useEffect, useState } from "react";
import BooleanQuestion from "../../FormInputElements/BooleanQuestion";
import SelectMachineField from "./SelectMachineField";
import OperationDetailsFields from "./OperationDetailsFields";

export default function FertilizerApplicationsForm({
  cropYear,
  setCropYear,
  farm,
  setFarm,
}) {
  const [usedFertilizer, setUsedFertilizer] = useState(false);

  useEffect(() => {
    let found = false;
    for (const application of cropYear.fertilizer_applications) {
      if (
        application?.machine_id ||
        Number(application?.hours_used) > 0 ||
        application?.application_date ||
        Number(application?.fuel_used_litres) > 0
      ) {
        found = true;
        break;
      }
    }
    setUsedFertilizer(found);
  }, [cropYear]);

  function handleFirstBooleanQuestion(e) {
    const nextValue = e.target.value === "true";
    setUsedFertilizer(nextValue);
    if (!nextValue) {
      setCropYear((current) => ({
        ...current,
        fertilizer_applications: [],
      }));
    }
  }

  function ensureApplication(index) {
    const nextApplications = [...cropYear.fertilizer_applications];

    while (nextApplications.length <= index) {
      nextApplications.push({
        machine_id: "",
        hours_used: 0,
        application_date: "",
        fuel_used_litres: "",
      });
    }

    return nextApplications;
  }

  function handleMachineChange(machineId, index) {
    const nextCropYear = { ...cropYear };
    nextCropYear.fertilizer_applications = ensureApplication(index);
    nextCropYear.fertilizer_applications[index].machine_id = machineId;
    setCropYear(nextCropYear);
  }

  function handleHoursChange(hoursUsed, index) {
    const nextCropYear = { ...cropYear };
    nextCropYear.fertilizer_applications = ensureApplication(index);
    nextCropYear.fertilizer_applications[index].hours_used = hoursUsed;
    setCropYear(nextCropYear);
  }

  function handleOperationDetailChange(field, value, index) {
    const nextCropYear = { ...cropYear };
    nextCropYear.fertilizer_applications = ensureApplication(index);
    nextCropYear.fertilizer_applications[index][field] = value;
    setCropYear(nextCropYear);
  }

  return (
    <div>
      <h5 className="mb-2 text-[16px] font-bold text-slate-800">
        Application passes
      </h5>
      <BooleanQuestion
        handleChange={handleFirstBooleanQuestion}
        fieldValue={usedFertilizer}
        modalTitle={"Fertilizer"}
        modalDescription={
          "Was commercial fertilizer or manure applied for the analyzed crop?"
        }
        fieldLabel={
          "Did you apply fertilizer or manure this crop year?"
        }
      />
      <div
        style={{ maxHeight: usedFertilizer ? "720px" : "0" }}
        className="w-full overflow-hidden transition-all duration-300"
      >
        <p className="mb-2 text-sm text-slate-600">Record the equipment and fuel for each fertilizer pass that applies.</p>
        {[
          { index: 0, label: "Pre-seed equipment" },
          { index: 1, label: "At-seeding equipment" },
          { index: 2, label: "Post-seed equipment" },
        ].map((operation) => {
          const fieldState =
            cropYear.fertilizer_applications[operation.index] || {
              application_date: "",
              machine_id: "",
              hours_used: 0,
              fuel_used_litres: "",
            };

          return (
            <div className="grid border-t border-slate-100 py-2 lg:grid-cols-[minmax(360px,1fr)_minmax(320px,1fr)] lg:gap-4" key={operation.label}>
              <SelectMachineField
                fieldLabel={operation.label}
                machineType={"TRACTOR"}
                farm={farm}
                setFarm={setFarm}
                fieldState={{
                  machine_id: fieldState.machine_id,
                  hours_used: fieldState.hours_used,
                }}
                handleHoursChange={(hoursUsed) =>
                  handleHoursChange(hoursUsed, operation.index)
                }
                handleMachineChange={(machineId) =>
                  handleMachineChange(machineId, operation.index)
                }
              />

              <OperationDetailsFields
                cropYear={cropYear.crop_year}
                operation={fieldState}
                dateField="application_date"
                dateLabel={`${operation.label.replace(" equipment", "")} date`}
                onChange={(field, value) =>
                  handleOperationDetailChange(field, value, operation.index)
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
